import { render, staticRenderFns } from "./TrainerTeachers.vue?vue&type=template&id=5d5e84ce&scoped=true&"
import script from "./TrainerTeachers.vue?vue&type=script&lang=js&"
export * from "./TrainerTeachers.vue?vue&type=script&lang=js&"
import style0 from "./TrainerTeachers.vue?vue&type=style&index=0&id=5d5e84ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e84ce",
  null
  
)

export default component.exports